import { useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_PAGE_NUMBER } from '../constants/searchParamKeys';
const canonicalUrl = document.querySelector('head link[rel="canonical"]');
const loc = window.location;
export const SEOCanonicalURL = () => {
    const { handle } = useParams();
    const [searchParams] = useSearchParams();
    const page = Number(searchParams.get(SEARCH_PARAM_KEY_PAGE_NUMBER) ?? 1);
    useEffect(() => {
        if (canonicalUrl === null || handle === undefined)
            return;
        canonicalUrl.href = `${loc.origin}/collections/${handle}${page > 1 ? `?${SEARCH_PARAM_KEY_PAGE_NUMBER}=${page}` : ''}`;
    }, [handle, page]);
    return null;
};
